import React, {ReactNode} from 'react';
import {FieldError, UseFormRegisterReturn} from 'react-hook-form';
import {Form} from 'react-bootstrap';
import {faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

interface ICommonInputTextDefaultProps {
    labelTextColor: 'text-white' | 'text-black';
}

const defaultProps: ICommonInputTextDefaultProps = {
    labelTextColor: 'text-black',
};

interface ICommonInputText extends ICommonInputTextDefaultProps {
    label?: string;
    id?: string;
    type: 'text' | 'password' | 'email' | 'number' | 'currency';
    hookRegister?: UseFormRegisterReturn;
    fieldError?: FieldError | undefined;
    icon?: ReactNode;
    disabled?: boolean;
    defaultValue?: string;
    readOnly?: boolean;
    placeHolder?: string;
    fillId?: string | number;
    inputClassName?: string;
    errorTextClassName?: string;
    value?: string | number | string[] | undefined;
    step?: string | number;
}

const CommonInputText = (props: ICommonInputText) => {
    const {
        label,
        type,
        hookRegister,
        fieldError,
        defaultValue,
        disabled,
        readOnly,
        placeHolder,
        inputClassName,
        value,
        errorTextClassName,
        step,
    } = props;
    const [show, setShow] = React.useState(false);

    let inputProps = {autoComplete: 'new-password'};
    const isPasswordInput = type === 'password';

    const getInputType = () => {
        if (isPasswordInput) {
            return show ? 'text' : 'password';
        }
        return type;
    };

    const getErrorMessage = () => {
        if (fieldError?.message) {
            return `*${fieldError.message}`;
        }
        return '';
    };

    const onClickError = () => {
        if (!fieldError?.ref?.focus) {
            return;
        }

        fieldError.ref.focus();
    };

    const getBorderColor = () => {
        if (fieldError) {
            return 'border-red-500 focus:border-red-500';
        }

        return 'focus:border-wsotMain-500';
    };

    return (
        <div className='p-0 d-flex flex-column w-100'>
            <div>
                {label ? <Form.Label>{label}</Form.Label> : null}
            </div>
            <div className='position-relative w-100'>
                <Form.Control
                    className={`${inputClassName} ${disabled ? 'disabled' : ''} ${getBorderColor()} ${isPasswordInput ? 'pe-5' : ''} w-100`}
                    type={getInputType()}
                    disabled={disabled}
                    {...(value && {value})}
                    {...(defaultValue && {defaultValue})}
                    readOnly={readOnly}
                    placeholder={placeHolder}
                    step={step}
                    {...hookRegister}
                    {...inputProps}
                />
                {isPasswordInput && (
                    <button
                        type='button'
                        className='btn btn-link position-absolute top-50 end-0 translate-middle-y py-0 px-3'
                        onClick={() => setShow(!show)}
                        tabIndex={-1}
                    >
                        <FontAwesomeIcon icon={show ? faEyeSlash : faEye} size='sm' className='fa-fw' />
                    </button>
                )}
            </div>
            {fieldError && (
                <p className={`input-error ${errorTextClassName}`} onClick={onClickError}>
                    {getErrorMessage()}
                </p>
            )}
        </div>
    );
};

CommonInputText.defaultProps = defaultProps;

export default CommonInputText;
